import "./firebaseConfig";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./Components/Navbar.js";
import Projects from "./Pages/ProjectsOverview.js";
import Contact from "./Pages/Contact.js";
import ProjectDetail from "./Pages/ProjectDetail";
import Home from "./Pages/Home";
import About from "./Pages/About";

function App() {
    return (
        <Router>
            <Navbar />
            <main>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/projects" element={<Projects />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/projects/:id" element={<ProjectDetail />} />
                </Routes>
            </main>
        </Router>
    );
}

export default App;
